import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { SharedModule } from "../shared/shared.module";
import { CompanyCardComponent } from "./company-card/company-card.component";
import { CompanyDetailsComponent } from "./company-details/company-details.component";
import { CompanyPrimaryAccountComponent } from "./company-primary-account/company-primary-account.component";
import { CompanyInfoComponent } from "./company-info/company-info.component";
import { CompanyFormComponent } from "./company-form/company-form.component";
import { CompanyImpersonateComponent } from "./company-impersonate/company-impersonate.component";
import { SubscriptionsSharedModule } from "../subscriptions/subscriptions-shared/subscriptions-shared.module";
import { AiDocumentProcessingComponent } from "./components/ai-document-processing/ai-document-processing.component";
import { ChatEnabledComponent } from "./components/chat-enabled/chat-enabled.component";
import { AccountScopesComponent } from "./components/account-scopes/account-scopes.component";
import { CompanyEburyMappingComponent } from "./company-ebury-mapping/company-ebury-mapping.component";
import { CompanyAccountManagersComponent } from "./company-account-managers/company-account-managers.component";
import { CompanyAccountManagersDialogComponent } from "./company-account-managers-dialog/company-account-managers-dialog.component";
import { AiTokensModule } from "../ai-tokens/ai-tokens.module";

@NgModule({
  declarations: [
    CompanyCardComponent,
    CompanyDetailsComponent,
    CompanyPrimaryAccountComponent,
    CompanyInfoComponent,
    CompanyFormComponent,
    CompanyImpersonateComponent,
    AiDocumentProcessingComponent,
    ChatEnabledComponent,
    AccountScopesComponent,
    CompanyEburyMappingComponent,
    CompanyAccountManagersComponent,
    CompanyAccountManagersDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    NgxSmartModalModule,
    SubscriptionsSharedModule,
    AiTokensModule,
  ],
  exports: [CompanyDetailsComponent],
})
export class CompanyModule {}
